module.exports = "https://static.cdns.space/tarot-temp/img/blog3-8.21789342.png";